import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import Modal from '@ublique/components/LoadingModal'
import { CloudUpload32, SubtractAlt16 } from '@carbon/icons-react'
import { FileUploaderDropContainer } from '@ublique/components/FileUploader'
import { formatFileSize } from './helpers'
import { errorsStore } from 'services/state'
import { isEmpty, last, uniqueId } from 'lodash'
import cn from 'classnames'
import './index.scss'

const ACCEPTED_EXTENSIONS = ['.xlsx', '.xls', '.csv', '.zip']

const ImportModal = ({
  open,
  close,
  data: { onSubmit, multiple = true, allowedExtension = ACCEPTED_EXTENSIONS }
}) => {
  const [files, setFiles] = useState([])
  const { t } = useTranslation(['Common', 'Shell'])

  const onAddFile = (_, params) => {
    const { addedFiles } = params
    const newFiles = addedFiles.map((file) => ({
      id: uniqueId(),
      file
    }))

    // "accept" prop in FileUploaderDropContainer is not working with drag and drop,
    // so we need to prevent files with extensions not includes in those accepted
    const filesAccepted = newFiles.filter(({ file }) => {
      const splittedFileName = file.name.split('.')
      const fileExtension = `.${splittedFileName[splittedFileName?.length - 1]}`
      return ACCEPTED_EXTENSIONS.includes(fileExtension)
    })

    if (multiple) {
      setFiles((prev) => [...prev, ...filesAccepted])
    } else {
      isEmpty(filesAccepted) ? setFiles([]) : setFiles([last(filesAccepted)])
    }
  }

  const onImport = async () => {
    try {
      close()
      // Removing ids before to send files
      const mappedFiles = files.map(({ file }) => file)
      await onSubmit(mappedFiles)
    } catch (error) {
      console.error(error)
      errorsStore.update(() => [])
    }
  }

  const removeSelectedFile = (fileId) => {
    const newFiles = files.filter(({ id }) => id !== fileId)
    setFiles(newFiles)
  }

  const renderMainContent = () => (
    <>
      <div className='import-modal-main-content'>
        <div
          className={cn('uploader-wrapper', {
            smaller: files?.length > 0
          })}
        >
          <FileUploaderDropContainer
            accept={allowedExtension}
            multiple
            labelText={
              <span>
                <CloudUpload32 />
              </span>
            }
            onAddFiles={onAddFile}
          />
        </div>
        {!isEmpty(files) && (
          <>
            <h6 className='file-recap-title'>{t('Shell:FileToImport')} </h6>
            <div className='file-recap'>
              {files.map(({ id, file }) => (
                <p key={id} className='file-item'>
                  <div className='file-name-item'>
                    <span>
                      {file.name} ({formatFileSize(file.size)})
                    </span>
                  </div>
                  <div className='file-action'>
                    <SubtractAlt16 onClick={() => removeSelectedFile(id)} />
                  </div>
                </p>
              ))}
            </div>
          </>
        )}
      </div>
    </>
  )

  const modalPropsMain = {
    onRequestSubmit: onImport,
    primaryButtonText: t('Shell:Import'),
    primaryButtonDisabled: isEmpty(files),
    secondaryButtonText: t('Common:Cancel')
  }

  return (
    <Modal
      open={open}
      onRequestClose={close}
      modalHeading={t('Shell:ImportTitle')}
      className='import-service-modal'
      preventCloseOnClickOutside
      {...modalPropsMain}
    >
      {renderMainContent()}
    </Modal>
  )
}

export default ImportModal
